import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { useStoreAlarm } from '@/entities/alarm'

import { pathNames } from '@/shared/utils/constants'

export const alarmSettingsBeforeEnter = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const { fetchAlarmSchedules, fetchPromptAlarmSubscriber } = useStoreAlarm()

  try {
    if (from.name !== 'alarm-item' && from.name !== pathNames.SUPPORT_ALARM_SCHEDULE_CREATE) {
      await Promise.all([fetchAlarmSchedules(), fetchPromptAlarmSubscriber()])
    }
    next()
  } catch (e) {
    console.error(e)
  }
}
